module.exports = __webpack_public_path__ + "img/lhb.ba91413a.svg";